import { SelectOptions } from 'components/commonType';
import {
  AdRequestSourceWebService,
  RecommendKeywordsResponse,
  RestfulAdRequestSourceWebService
} from 'ws/AdRequestSourceWebService';
import { ECSegmentWebService, RestfulECSegmentWebService } from 'ws/ECSegmentWebService';
import { ECSegmentStatus } from 'core/ecSegment/ECSegment';
import i18n from 'i18n';
import { numberWithCommas } from 'utils/StringUtil';

const EMPTY_RECOMMEND_RESPONSE: RecommendKeywordsResponse = {
  recommendPool: [],
  enrichedSelected: []
};

export interface AdRequestSourceManager {
  getOS (): Promise<SelectOptions[]>;
  getSpaceTypes (): Promise<SelectOptions[]>;
  getDevice (): Promise<SelectOptions[]>;
  getRecommendKeywords (input: { goodsCodes: string[], selectedKeywords: string[] }): Promise<RecommendKeywordsResponse>;
  getECSegmentOptions (advertiserId: number): Promise<SelectOptions[]>;
}

export class DefaultAdRequestSourceManager implements AdRequestSourceManager {

  constructor (
    private webService: AdRequestSourceWebService = new RestfulAdRequestSourceWebService(),
    private ecSegmentWebService: ECSegmentWebService = new RestfulECSegmentWebService()
  ) {}
  getOS (): Promise<SelectOptions[]> {
    return this.webService.getOS();
  }
  getSpaceTypes (): Promise<SelectOptions[]> {
    return this.webService.getSpaceTypes();
  }
  getDevice (): Promise<SelectOptions[]> {
    return this.webService.getDevice();
  }
  async getRecommendKeywords (input: { goodsCodes: string[], selectedKeywords: string[] }): Promise<RecommendKeywordsResponse> {
    if (input.goodsCodes.length === 0 && input.selectedKeywords.length === 0) {
      return EMPTY_RECOMMEND_RESPONSE;
    }
    return this.webService.getRecommendKeywords(input);
  }

  async getECSegmentOptions (advertiserId: number): Promise<SelectOptions[]> {
    const ecSegments =
      await this.ecSegmentWebService.getECSegments(
        advertiserId,
        [
          ECSegmentStatus.ACTIVE,
          ECSegmentStatus.UNBOUND,
          ECSegmentStatus.UPDATING,
          ECSegmentStatus.OVERLY_RESTRICTIVE
        ]
      );

    const getNumberRange = (num: number): string => {
      const numStr = num.toString();
      const length = numStr.length;

      if (length === 1) {
        return '1 ~ 9';
      }

      if (length === 2) {
        return '10 ~ 99';
      }

      const prefix = numStr.slice(0, 2);
      const postfix = ''.padEnd(length - 2, '0');
      const lowerBound = prefix + postfix;
      const upperBound = (parseInt(prefix, 10) + 1) + postfix;
      return `${numberWithCommas(lowerBound)} ~ ${numberWithCommas(upperBound)}`;
    };

    return ecSegments.map((segment) => {

      let extra = i18n.t<string>('limitation.labels.peopleNumberTip', { value: getNumberRange(segment.visitors) });
      return {
        label: segment.name,
        value: segment.id,
        extra
      };
    });
  }
}
